export default "__VITE_ASSET__0575201f__"